import { observer } from 'mobx-react-lite'
import { useLocation } from 'react-router'
import { useEffect, type MouseEvent } from 'react'
import classNames from 'classnames'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { Portal, getAriaLabel } from 'shared/lib'
import { ModalContent } from 'shared/ui/Modal/ModalContent'
import { ZIndex } from 'shared/constants/zIndex'
import styles from './styles.module.scss'

export const Modal = observer(() => {
  const { pathname } = useLocation()
  const { hideModalIdsSet, disabledOverlayClose } = modalStore
  const onOverlayClick = (e: MouseEvent<HTMLDivElement>, id: string) => {
    if (disabledOverlayClose(id)) return
    const overlayElement = document.querySelector(`#modal-overlay-${id}`)
    const parentElement = document.querySelector(`#modal-card-${id}`)
    const clickedElement = e.target

    if (overlayElement && clickedElement instanceof Node) {
      if (!overlayElement.contains(clickedElement)) return

      if (parentElement) {
        if (!parentElement.contains(clickedElement)) {
          e.stopPropagation()
          modalStore.closeModal(id)
        }
      }
    }
  }

  useEffect(() => {
    modalStore.closeAllModals()
  }, [pathname])

  return (
    <>
      {modalStore.modals.map((modal) => {
        const ariaLabelRoot = 'Modal'

        return (
          <Portal key={modal.id} zIndex={modal.zIndex || ZIndex.OVERLAY_BASE}>
            <div
              id={`modal-overlay-${modal.id}`}
              className={classNames(styles.wrap, { [styles.hide]: hideModalIdsSet.has(modal.id) })}
              onClick={(e) => onOverlayClick(e, modal.id)}
              aria-label={getAriaLabel(
                ariaLabelRoot,
                String(('title' in modal && modal.title) || modal.ariaLabel)
              )}
            >
              <ModalContent modal={modal} hide={hideModalIdsSet.has(modal.id)} />
            </div>
          </Portal>
        )
      })}
    </>
  )
})
